import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/agent-workspace/automations')({
  beforeLoad: () => {
    throw redirect({ to: '/automations' })
  },
})
